import lottie from 'lottie-web'
import gsap from 'gsap'
import MotionTime from './MotionTime'

import fryItUppath from '../../anims/motiontime/fryitup.json'

export default class FryItUp {
    constructor() {
        // Fry it up
        this.fryItUpTimeouts = []
        this.allWorks = [...document.querySelectorAll('.works__listing .work')]

        this.containers = [
            document.querySelector('.hover__visuel-one'),
            document.querySelector('.hover__visuel-two'),
            document.querySelector('.hover__visuel-three'),
        ]

        this.motionTime = new MotionTime()

        this.mouseOverEventsInstances = []
        this.mouseLeaveEventsInstances = []

        this.touchStartEventsInstances = []
        this.touchEndEventsInstances = []

        this.init()
    }

    init() {
        this.initMouseEvents()
        this.initTouchEvents()
    }

    initMouseEvents() {
        this.allWorks.forEach((work, index) => {
            this.mouseOverEventsInstances[index] = () => {
                this.enteringEvent(work, index)
            }

            this.mouseLeaveEventsInstances[index] = () => {
                this.leavingEvent(work, index)
            }

            work.addEventListener(
                'mouseover',
                this.mouseOverEventsInstances[index]
            )

            work.addEventListener(
                'mouseleave',
                this.mouseLeaveEventsInstances[index]
            )
        })
    }

    initTouchEvents() {
        this.allWorks.forEach((work, index) => {
            this.touchStartEventsInstances[index] = () => {
                this.enteringEvent(work, index)
            }
            this.touchEndEventsInstances[index] = () => {
                this.leavingEvent(work, index)
            }

            work.addEventListener(
                'touchstart',
                this.touchStartEventsInstances[index]
            )

            work.addEventListener(
                'touchend',
                this.touchEndEventsInstances[index]
            )
        })
    }

    enteringEvent(work, index) {
        work.classList.add('fryitup--charging')
        if (!work.classList.contains('fryitup')) {
            this.fryItUpTimeouts[index] = setTimeout(() => {
                gsap.to(this.containers, {
                    stagger: 0.05,
                    opacity: 0,
                    duration: 0.1,
                    scale: 1.2,
                    ease: 'expo.easeOut',
                })

                work.classList.add('fryitup')
                let animContainer = work.querySelector('.fryitup__container')
                animContainer.innerHTML = ''

                const fryItUpLottieInstance = lottie.loadAnimation({
                    path: fryItUppath,
                    container: animContainer,
                    renderer: 'svg',
                    autoplay: false,
                    loop: false,
                    rendererSettings: {
                        preserveAspectRatio: 'none',
                    },
                })

                this.motionTime.unlockItem(0)

                fryItUpLottieInstance.addEventListener('complete', () => {
                    work.classList.remove('fryitup')
                })

                setTimeout(() => {
                    fryItUpLottieInstance.play()
                }, 100)

                fryItUpLottieInstance.addEventListener('enterFrame', () => {
                    if (
                        fryItUpLottieInstance.currentRawFrame >= 35 &&
                        fryItUpLottieInstance.currentRawFrame < 80
                    ) {
                        work.classList.add('fryitup--energy')
                    } else {
                        work.classList.remove('fryitup--energy')
                    }
                })
            }, 3000)
        }
    }

    leavingEvent(work, index = false) {
        if (!index) {
            index = Array.from(
                document.querySelectorAll('.works__listing .work')
            ).indexOf(work)
        }
        work.classList.remove('fryitup--charging')
        clearTimeout(this.fryItUpTimeouts[index])
        this.fryItUpTimeouts[index] = null
    }

    destroyAll() {
        this.allWorks.forEach((work, index) => {
            this.leavingEvent(work, index)
            work.removeEventListener(
                'mouseover',
                this.mouseOverEventsInstances[index]
            )
            work.removeEventListener(
                'mouseleave',
                this.mouseLeaveEventsInstances[index]
            )

            work.addEventListener(
                'touchstart',
                this.touchStartEventsInstances[index]
            )
            work.addEventListener(
                'touchend',
                this.touchEndEventsInstances[index]
            )
        })
    }
}
